import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup } from "vue"


import Attachment from 'SharedComponents/Attachments/Attachment.vue';
import AttachmentSkeleton from 'SharedComponents/Attachments/AttachmentSkeleton.vue';
import { FsView } from 'SharedDir/constants/file-system';
import { AttachmentType } from 'SharedDir/declarations/files';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'AttachmentCollection' },
  __name: 'AttachmentCollection',
  props: {
    list: {},
    view: { default: FsView.tile },
    hidePreview: { type: Boolean, default: false }
  },
  setup(__props: any) {


const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    tag: "div",
    name: "fade"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (attachment, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          attachment
            ? (_openBlock(), _createBlock(Attachment, {
                key: attachment.id,
                view: _ctx.view,
                data: attachment,
                "hide-preview": _ctx.hidePreview
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "attachment-control", {
                    attachment: attachment,
                    index: index
                  })
                ]),
                _: 2
              }, 1032, ["view", "data", "hide-preview"]))
            : (_openBlock(), _createBlock(AttachmentSkeleton, {
                key: index,
                view: _ctx.view
              }, null, 8, ["view"]))
        ], 64))
      }), 256))
    ]),
    _: 3
  }))
}
}

})